<template>
  <BaseMenu
    :close-on-content-click="false"
    offset-y
    bottom
    :nudge-bottom="4"
    @input="onMenuToggle"
  >
    <template #activator="{ on, attrs }">
      <BaseButton
        :outlined="value === null"
        :type="value !== null ? 'primary' : 'secondary'"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">{{ mdiAccountOutline }}</v-icon>
        {{ selectedLabel }}
        <v-icon small class="ml-1">{{ mdiChevronDown }}</v-icon>
      </BaseButton>
    </template>
    <template #content>
      <div class="filter_menu_content">
        <v-text-field
          v-model="search"
          dense
          outlined
          hide-details
          :placeholder="$t('folder.filters.searchPlaceholder')"
          prepend-inner-icon="$mdiMagnify"
          class="search_field"
          autofocus
        />
        <div
          class="contact_item"
          :class="{ selected: value === null }"
          @click="$emit('input', null)"
        >
          {{ $t("folder.filters.allContacts") }}
        </div>
        <template v-if="!fetching">
          <div
            v-for="contact in contacts"
            :key="contact.id"
            class="contact_item"
            :class="{ selected: value === contact.id }"
            @click="selectContact(contact)"
          >
            {{ contact.email }}
          </div>
          <div v-if="!contacts.length" class="no_result">
            {{ $t("folder.filters.noResult") }}
          </div>
        </template>
        <div v-else class="loading">
          <v-progress-circular indeterminate size="20" width="2" color="primary" />
        </div>
      </div>
    </template>
  </BaseMenu>
</template>

<script>
import { mdiAccountOutline, mdiChevronDown } from "@mdi/js";
import ClientAPI from "@/modules/Client/Services/client.api";

export default {
  name: "WorkflowFolderContactFilter",
  props: {
    value: {
      type: Number,
      default: null,
    },
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      mdiAccountOutline,
      mdiChevronDown,
      search: "",
      contacts: [],
      fetching: false,
      searchTimeoutRef: null,
      selectedContactEmail: null,
    };
  },
  computed: {
    selectedLabel() {
      if (this.value === null) return this.$t("folder.filters.allContacts");
      const found = this.contacts.find((c) => c.id === this.value);
      if (found) return found.email;
      return this.selectedContactEmail ?? this.$t("folder.filters.contact");
    },
  },
  watch: {
    search() {
      clearTimeout(this.searchTimeoutRef);
      this.searchTimeoutRef = setTimeout(() => {
        this.fetchContacts();
      }, 300);
    },
  },
  created() {
    this.fetchContacts();
  },
  methods: {
    selectContact(contact) {
      this.selectedContactEmail = contact.email;
      this.$emit("input", contact.id);
    },
    async fetchContacts() {
      this.fetching = true;
      try {
        const res = await ClientAPI.getOrganizationClients(
          this.organizationId,
          1,
          20,
          this.search
        );
        this.contacts = res.data.results ?? res.data;
      } catch {
        // silently fail
      }
      this.fetching = false;
    },
    onMenuToggle(isOpen) {
      if (!isOpen) {
        clearTimeout(this.searchTimeoutRef);
        this.search = "";
        this.fetchContacts();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter_menu_content {
  padding: 8px;
  min-width: 280px;
  background: white;

  .search_field {
    margin-bottom: 4px;
  }
}

.contact_item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;

  &:hover {
    background: #f4f7ff;
  }

  &.selected {
    background: #e6eff4;
    font-weight: 600;
  }
}

.no_result,
.loading {
  padding: 12px;
  text-align: center;
  font-size: 13px;
  color: #9e9e9e;
}
</style>
